interface SegmentedControlProps<T extends string = string> {
  options: string[];
  value: T;
  onChange?: (value: T) => void;
}

export function SegmentedControl<T extends string>({ options, value, onChange }: SegmentedControlProps<T>) {
  return (
    <div className="flex items-center gap-1 bg-paper rounded-md p-0.5 border border-ink/8">
      {options.map((option) => (
        <button
          key={option}
          onClick={() => onChange?.(option as T)}
          className={`
            px-3 py-1 text-[12px] rounded-sm transition-colors
            ${value === option
              ? 'bg-paper-hi shadow-card font-medium'
              : 'text-ink-4 hover:text-ink-2'
            }
          `}
        >
          {option}
        </button>
      ))}
    </div>
  );
}
